module.exports = __webpack_public_path__ + "static/media/Wechat_Pay_Chinese_Logo.18426163.svg";